// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 768) return "static/chunks/768-4cbf851ed5b8daf4.js";
	// return url for filenames based on template
	return "static/chunks/" + "d0f5a89a" + "." + "da598f70a404ff65" + ".js";
};